import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Endpoints} from '../config/endpoints';

export interface AppConfig {
    apiUrl: string;
    mapApiKey: string;
    // Add other config properties
}

@Injectable({providedIn: 'root'})
export class AppConfigService {
    private config: AppConfig;

    constructor(private http: HttpClient) {
    }

    load(): Promise<void> {
        return this.http.get<AppConfig>(Endpoints.environment_config)
            .toPromise()
            .then((data) => {
                this.config = data;
            });
    }

    get apiUrl(): string {
        return this.config ? this.config.apiUrl : '';
    }

    get mapApiKey(): string {
        return this.config ? this.config.mapApiKey : '';
    }
}
